module.exports = __webpack_public_path__ + "img/step8.24562b26.png";